<template>

    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" height="28" width="28"
	 viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">

<g>
	<path class="st0" d="M15,19.9c-0.4,0-0.7-0.2-0.9-0.6l-2.9-6l-1,2.1C10,15.8,9.6,16,9.2,16H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h7.6
		l1.6-3.3c0.3-0.7,1.5-0.7,1.8,0l2.9,6l2.9-6c0.2-0.3,0.5-0.6,0.9-0.6l0,0c0.4,0,0.7,0.2,0.9,0.6l1.6,3.3H29c0.6,0,1,0.4,1,1
		s-0.4,1-1,1h-8.2c-0.4,0-0.7-0.2-0.9-0.6l-1-2.1l-2.9,6C15.7,19.7,15.4,19.9,15,19.9z"/>
</g>
<g>
	<path class="st0" d="M1.9,11C1.9,11,1.9,10.9,1.9,11c-0.1-0.4-0.1-0.7-0.1-1c0-3.8,3.1-6.9,6.9-6.9c1.9,0,3.6,0.7,4.9,2.1L15,6.6
		l1.3-1.4c1.3-1.3,3.1-2.1,4.9-2.1c3.8,0,6.9,3.1,6.9,6.9c0,0.3,0,0.6-0.1,0.8c0,0,0,0.1,0,0.1h1.9c0-0.3,0.1-0.6,0.1-1
		c0-4.8-3.9-8.7-8.7-8.7c-2.5,0-4.7,1-6.3,2.6c-1.6-1.6-3.8-2.6-6.3-2.6C3.9,1.3,0,5.2,0,10c0,0.3,0,0.6,0.1,1H1.9z"/>
	<path class="st0" d="M25.5,17c-2,2.8-5,5.2-7.9,7.7c-0.9,0.7-1.7,1.4-2.6,2.2c-0.8-0.7-1.7-1.5-2.6-2.2c-2.9-2.4-5.9-4.9-7.9-7.7
		H2.2c2.7,4.3,7.5,7.7,11.6,11.3c0.7,0.6,1.7,0.6,2.4,0c4.1-3.5,8.9-7,11.6-11.3H25.5z"/>
</g>
</svg>

</template>

<script>
    export default {
        name: "BH_svg"
    }
</script>




// WEBPACK FOOTER //
// src/common/components/svg/chapter/BH_svg.vue